import { USER_URL } from "../constant/api";

export const OrderCheckOutApi = async () => {
  try {
    const response = await USER_URL.get("orders/checkout/");
    console.log(response.data);
    return response.data;
  } catch (error) {
    console.log("error in order checkout", error);
    throw error;
  }
};


// order place

export const OrderPlace = async () => {
  try {
    const response = await USER_URL.post("/orders/place-order/");
    console.log(response.data);
    return response.data;
  } catch (error) {
    console.log("error in order checkout", error);
    throw error;
  }
};